import * as React from 'react';
import { Dispatch } from 'redux';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';

import { buttonStyles } from '../../../styles/base';
import { DarkLawn } from '../Lawn';
import { HouseSunset } from '../HouseIcons';
import combineStyles from '../../../styles/combineStyles';
import styles from './styles';
import { useRouter } from 'next/router';

const combinedStyles = combineStyles(buttonStyles, styles);

export interface Props {
  classes: any;
  headerText?: string;
  subText?: string;
  subText2?: string;
  subText3?: string;
  topper: boolean;
}

export function SignupCta(props: Props) {
  const router = useRouter();
  const openSignup = () => {
    const { asPath } = router;
    router.push({
      pathname: '/signup/onboarding',
      query: {
        stage: 'intro',
        question: 'cover',
        signupPath: encodeURI(asPath),
      },
    });
  };

  const { classes, topper } = props;
  const headerText = props.headerText || 'Get Started';
  const subText =
    props.subText ||
    'Download the Torii app to make an offer or get started online';
  const subText2 = props.subText2 || 'Currently available in Massachusetts';
  return (
    <div className={`row center-xs bottom-xs ${classes.getStarted}`}>
      {topper && <div className={classes.getStartedTopper} />}
      <div className={classes.inner}>
        <h2 className={classes.getStartedHeader}>{headerText}</h2>
        <p className={classes.subHeader}>
          {subText}
          <br className="no-mobile" />
          <span className="mobile-only"> </span>
          {subText2}
        </p>
        <div className={classes.signupButtonContainer}>
          <Button
            variant="contained"
            size="large"
            className={classes.buttonLargeGreen}
            type="button"
            onClick={openSignup}
          >
            SIGN UP
          </Button>
        </div>
      </div>

      <div className={classes.lawnContainer}>
        <div className={classes.lawnInner}>
          <DarkLawn />
        </div>
      </div>
      <div className={classes.houseIconContainer}>
        <div className={classes.houseIcon}>
          <HouseSunset />
        </div>
      </div>
    </div>
  );
}

export default withStyles(combinedStyles)(SignupCta);
